require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-beginning-of-code-fellows.json") })
        }
      }, "path---blog-the-beginning-of-code-fellows");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-beginning-of-code-fellows!./.cache/json/blog-the-beginning-of-code-fellows.json
// module id = 1097
// module chunks = 231608221292675